(function(){
  var useBoltConfirmationPage = false
  var noShopifyConfirmationSlicing = true;
  
  
  // DO NOT MODIFY BEYOND THIS POINT (UNLESS SPECIALLY REFERENCED MODIFICATION)
  var orderNote = ""
  var cartUpdateURLs = [
    '/cart/change.js',
    '/cart/update.js',
    '/cart/add.js',
  ];
  var trackGaStep = function(step) {
    if (!enableGaTracking) {
      return;
    }
    ga('ec:setAction','checkout', {
      'step': step,
    });
    ga('send', 'event', 'Checkout', 'step');
  };

  function loadCart() {
    if (typeof BoltCheckout === "undefined") {
      return;
    }
    
    var traditionalButtonAvailable = (typeof $ !== "undefined" && $(".bolt-checkout-button") && $(".bolt-checkout-button").length === 0)
    var instantButtonAvailable = (typeof $ !== "undefined" && $("div").find(`[data-tid='instant-bolt-checkout-button']`) && $("div").find(`[data-tid='instant-bolt-checkout-button']`).length === 0)
    
    if (!traditionalButtonAvailable && !instantButtonAvailable) {
      // Not a cart page.
      return;
    }
    
    var hints = {};
    var tax_exempt = false;
    
    var Shopifyhints = {};
  	var discountShippingParams = {};
    var callbacks ={
        check: function() {
          return true
        },
        onCheckoutStart: function() {
        },
        onShippingDetailsComplete: function() {
        },
        onShippingOptionsComplete: function() {
        },
        onPaymentSubmit: function() {
         },
        success: function(transaction, callback) {
          reference = transaction.reference;
        }
    };
    Shopifyhints["useBoltOrderConfirmationPage"] = useBoltConfirmationPage;
	Shopifyhints["noShopifyConfirmationSlicing"] = noShopifyConfirmationSlicing;
  
//   if (typeof(window.local_storage.discount_code) !== "undefined" && window.local_storage.discount_code !== null ) {
//     hints["discount_code"] = window.discount_code
//   }
  
    BoltCheckout.configureShopify(Shopifyhints, hints, callbacks);
  }
 
  $(document).ready(function(){
    $(document).ajaxComplete(function(event, xhr, settings) {
      for (var i = 0; i < cartUpdateURLs.length; i++) {
        if (settings && settings.url.includes(cartUpdateURLs[i]) && (!settings.data || !(settings.data.includes("bolt=true")))) {
          loadCart();
        }
      }
    });
  
    window.fetch = new Proxy(window.fetch, {
      apply(fetch, that, args) {
        return fetch.apply(that, args).then((response) => {
          const url = args[0];
          const cartIsUpdated = cartUpdateURLs.findIndex(cartUpdateURL => url.includes(cartUpdateURL)) >= 0;
          if(cartIsUpdated){
            loadCart();
          }
          return response;
        });
      }
    });
  
    loadCart();
    window.boltLoadCart = loadCart;
    $(".bolt-checkout-button").css("width", "auto");
    $(document).on('DOMNodeInserted', function(e) {
      if ($(e.target).hasClass('bolt-checkout-button-button')) {
        $(e.target).css("margin-right", "0px");
        $(e.target).css("width", "100%");
      }
      if ($(e.target).hasClass('bolt-checkout-button-cards')) {
        $(e.target).css("float", "none");
        $(e.target).css("width", "auto");
      }
    });
   
  });
})();

if (typeof BoltCheckout !== "undefined") {
  BoltCheckout.configure();
}
